import React from 'react'
import Field from '@/components/Field'
import { Input } from '@/components/Inputs'
import { ControlledInputAddress } from '../components/ControlledInputAddress'
import { useFormContext } from 'react-hook-form'
import { useTransferDispatch } from '../TransferProvider'
import { TRANSFER_FORM_INPUTS } from '../constants'

export const TransferForm = () => {
  const { register } = useFormContext()

  const dispatch = useTransferDispatch()

  return (
    <div className="flex flex-col gap-3 mb-1">
      <Field name={TRANSFER_FORM_INPUTS.to} label={'Destination Address'}>
        <ControlledInputAddress
          onValidAddress={({ value, captcha_enabled }) => {
            dispatch({
              type: 'SET_TO_ADDRESS',
              payload: { to: value, captcha_enabled }
            })
          }}
          name={TRANSFER_FORM_INPUTS.to}
          placeholder="Wax Destination Address"
        />
      </Field>

      <Field name={TRANSFER_FORM_INPUTS.memo} label={'Memo'} optional>
        <Input
          className="!h-13"
          name={TRANSFER_FORM_INPUTS.memo}
          register={register(TRANSFER_FORM_INPUTS.memo)}
          format="textarea"
          placeholder="Memo"
        />
      </Field>
    </div>
  )
}
